import { handleActions } from 'redux-actions';
import * as actions from '../actions';

const defaultState = {
  current: {
    authors: [],
    sites: [],
    categories: [],
    starred: false,
    flaggedForEditor: false,
    promoted: false,
    hidePublishDate: false,
  },
  resultsPageCount: 0,
  resultsItemCount: 0,
  count: 0,
  offset: 0,
  post: {},
  query: {
    limit: 10,
    offset: 0,
    site: '',
    status: '0,1,2,5',
    start_date: 'All Time',
    end_date: 'All Time',
    author_id: '',
    author_name: '',
    q: '',
    type: '',
    time: 'All Time',
    section: '',
    sort: { field: 'created_ts', direction: 'DESC' },
  },
  newsItems: [],
  authors: [],
  categories: [],
  sites: [],
};

const reducer = handleActions(
  {
    [actions.content.getNewsItemsSuccess]: (state, { payload: { newsItems, resultsItemCount, resultsPageCount } }) => {
      return { ...state, newsItems, resultsItemCount, resultsPageCount };
    },
    [actions.content.setNewsItemQuery]: (state, { payload: { query } }) => {
      return { ...state, query: { ...state.query, ...query } };
    },
    [actions.content.getPostByIdSuccess]: (state, { payload: { post } }) => {
      return { ...state, post };
    },
    [actions.content.setNewsItemPage]: (state, { payload: { offset } }) => {
      return { ...state, offset };
    },
    [actions.content.setNewsItemCount]: (state, { payload: { count } }) => {
      return { ...state, count };
    },
    [actions.content.getNewsItemByIdSuccess]: (state, { payload: { newsItem } }) => {
      return { ...state, current: newsItem };
    },
    [actions.content.getAuthorsSuccess]: (state, { payload: { authors } }) => {
      return { ...state, authors };
    },
    [actions.content.getSitesSuccess]: (state, { payload: { sites } }) => {
      return { ...state, sites };
    },
    [actions.content.addNewsItemSuccess]: (state, { payload: { newsItem } }) => {
      return { ...state, current: newsItem };
    },
    [actions.content.enhanceNewsItemSuccess]: (state, { payload: { newsItem } }) => {
      const item = state.newsItems.find(x => x.id === newsItem.id);
      const index = state.newsItems.indexOf(item);
      const newsItems = [...state.newsItems];
      newsItems[index] = newsItem;
      return { ...state, newsItems };
    },
  },
  defaultState
);

export default reducer;
